import { Navigate } from "react-router-dom";
import * as utils from '../common/utils';

const ProtectedRoute: React.FC<{children: JSX.Element}> = ({children})=> {
    return utils.checkLogin()? children:  <Navigate to="/login" replace />;
}

export default ProtectedRoute;